import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentUserService } from "../../services/getCurrentUser";

export const getCurrentUser = createAsyncThunk("get/currentuser", async () => {
  return await getCurrentUserService();
});
